import ZiniHubAdminUXWizard from "./ZiniHubAdminUXWizard";

export default ZiniHubAdminUXWizard;
